import { isEmpty } from "lodash-es";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useDeleteAPIKeys } from "../../hooks/settings/useDeleteAPIKeys";
import { useConfirm } from "melco-shared-logic";

type BulkActionDeleteAPIKeysProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
};

export const BulkActionDeleteAPIKeys: React.FC<
  BulkActionDeleteAPIKeysProps
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();
  const deleteAPIKeys = useDeleteAPIKeys();

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteAPIKeys(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "api_list.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("api_list.actions.delete.button")}
    </Button>
  );
};
